/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seller_Dashboard_Setup_StorefrontInputs */

const en_seller_dashboard_setup_storefront = /** @type {(inputs: Seller_Dashboard_Setup_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set Up Storefront`)
};

const es_seller_dashboard_setup_storefront = /** @type {(inputs: Seller_Dashboard_Setup_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configurar tienda`)
};

const fr_seller_dashboard_setup_storefront = /** @type {(inputs: Seller_Dashboard_Setup_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configurer la vitrine`)
};

const de_seller_dashboard_setup_storefront = /** @type {(inputs: Seller_Dashboard_Setup_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Storefront einrichten`)
};

const ja_seller_dashboard_setup_storefront = /** @type {(inputs: Seller_Dashboard_Setup_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ストアフロントを設定`)
};

const zh_seller_dashboard_setup_storefront = /** @type {(inputs: Seller_Dashboard_Setup_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`设置店铺`)
};

const ar_seller_dashboard_setup_storefront = /** @type {(inputs: Seller_Dashboard_Setup_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إعداد واجهة المتجر`)
};

const id_seller_dashboard_setup_storefront = /** @type {(inputs: Seller_Dashboard_Setup_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siapkan Etalase`)
};

const it_seller_dashboard_setup_storefront = /** @type {(inputs: Seller_Dashboard_Setup_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configura Vetrina`)
};

const ru_seller_dashboard_setup_storefront = /** @type {(inputs: Seller_Dashboard_Setup_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Настроить витрину`)
};

const pt_seller_dashboard_setup_storefront = /** @type {(inputs: Seller_Dashboard_Setup_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configurar Vitrine`)
};

const ko_seller_dashboard_setup_storefront = /** @type {(inputs: Seller_Dashboard_Setup_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`스토어프론트 설정`)
};

/**
* | output |
* | --- |
* | "Set Up Storefront" |
*
* @param {Seller_Dashboard_Setup_StorefrontInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const seller_dashboard_setup_storefront = /** @type {((inputs?: Seller_Dashboard_Setup_StorefrontInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seller_Dashboard_Setup_StorefrontInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_seller_dashboard_setup_storefront(inputs)
	if (locale === "es") return es_seller_dashboard_setup_storefront(inputs)
	if (locale === "fr") return fr_seller_dashboard_setup_storefront(inputs)
	if (locale === "de") return de_seller_dashboard_setup_storefront(inputs)
	if (locale === "ja") return ja_seller_dashboard_setup_storefront(inputs)
	if (locale === "zh") return zh_seller_dashboard_setup_storefront(inputs)
	if (locale === "ar") return ar_seller_dashboard_setup_storefront(inputs)
	if (locale === "id") return id_seller_dashboard_setup_storefront(inputs)
	if (locale === "it") return it_seller_dashboard_setup_storefront(inputs)
	if (locale === "ru") return ru_seller_dashboard_setup_storefront(inputs)
	if (locale === "pt") return pt_seller_dashboard_setup_storefront(inputs)
	return ko_seller_dashboard_setup_storefront(inputs)
});